// generated by Neptune Namespaces v4.x.x
// file: Art.StandardLib/Inspect/index.js

(module.exports = require('./namespace'))
.includeInNamespace(require('./Inspect'))
.addModules({
  AlignTabs:              require('./AlignTabs'),
  FormattedInspect:       require('./FormattedInspect'),
  FormattedInspectArray:  require('./FormattedInspectArray'),
  FormattedInspectObject: require('./FormattedInspectObject'),
  FormattedInspectString: require('./FormattedInspectString'),
  InspectedObjectLiteral: require('./InspectedObjectLiteral'),
  InspectedObjects:       require('./InspectedObjects'),
  Inspector:              require('./Inspector'),
  Inspector2:             require('./Inspector2'),
  PlainObjects:           require('./PlainObjects')
});
require('./Inspected');